// extracted by mini-css-extract-plugin
module.exports = {"submit":"LoginForm_submit_24-o1"};